import React, { FC } from 'react';

import { Container } from 'components/controls';
import WiseBreadcrumbsControl from 'components/controls/wise/WiseBreadcrumbsControl';

import styles from './WiseBreadcrumbs.module.scss';

interface IProps {
  isLoading?: boolean;
}

const WiseBreadcrumbs: FC<IProps> = ({ isLoading }) => (
  <div className={styles.wiseBreadcrumbsContainer}>
    <Container>
      <div className={styles.wiseBreadcrumbsPanel}>
        <WiseBreadcrumbsControl isLoading={isLoading} />
      </div>
    </Container>
  </div>
);

export default WiseBreadcrumbs;
